'use strict';

/**
 * View for rendering a single location / storage
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/collection/modules/location/templates/partials/meta-storages-item.hbs');

require('jquery-humans-dnd');

var MetaStoragesItemView = ItemView.extend({
    wrapItem: false,

    template: template,

    modelEvents: {
        'change': 'render',
    },

    onRender: function() {
        ItemView.prototype.onRender.apply(this, arguments);

        this.$el.humansDrop({
            overClass: 'drop-target-over',
            onDrop: function(event, humansDrop, humansDrag, element) {
                var catalog = this.getOption('catalog');

                var objectId    = humansDrag.getTargetElement().data('id');
                var objectModel = catalog.objects.get(objectId);
                var storageModel = this.model;

                App.radio('collection').execute(
                    'change:storage',
                    objectModel,
                    storageModel
                );
            }.bind(this),
        });
    },

    onBeforeDestroy: function() {
        this.$el.humansDrop('destroy');
    },
});

module.exports = MetaStoragesItemView;